import DelhiReportExport from "../Reports/DelhiReports/DelhiReportExport";

export const ExportHandHeldReaderCollection = ({
  reportData = [],
  columns = [],
}) => (
  <DelhiReportExport
    reportData={reportData}
    reportTitle="Hand Held Reader Collection"
    columns={columns}
    fileName="HandHeldReaderCollection"
  />
);
